import React from 'react'
import Faq from "../../components/Faq/Faq"

const FaqPage = () => {
  return (
    <Faq></Faq>
  )
}

export default FaqPage